import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { Device } from 'types';

export interface DeviceFrequencyVirtualDeviceCardProps {
    device: Device;
}

export const DeviceFrequencyVirtualDeviceCard = ({
    device,
}: DeviceFrequencyVirtualDeviceCardProps) => {
    return (
        <Card data-testid="DeviceFrequencyVirtualDeviceCard">
            <CardHeader title="No Frequency Settings Available" />
            <CardContent>
                Frequency settings are not available for {device.name} (
                {device.customer_name}) because it is a virtual monitor.
            </CardContent>
        </Card>
    );
};
